import React from 'react';
import { useLanguage } from '../context/LanguageContext';
export function Marquee() {
  const {
    t
  } = useLanguage();
  const loop = [...t.marquee, ...t.marquee];
  return <section aria-hidden className="bg-texture-espresso text-cream border-y border-cream/10 py-8 overflow-hidden" data-id="element-260" data-mp="2ijnk48uo3hsz">
      <div className="flex items-center whitespace-nowrap animate-marquee" data-id="element-261" data-mp="2dlcbu2k0tfcv">
        {loop.map((w, i) => <div key={i} className="flex items-center shrink-0" data-id="element-262" data-mp="3b7a0khozugx9" data-mpi={i}>
            <span className="font-serif italic text-3xl lg:text-4xl text-cream/85 font-light px-6" data-id="element-263" data-mp="3698dzmsczzh1">
              {w}
            </span>
            <span className="w-1.5 h-1.5 rounded-full bg-caramel shrink-0" data-id="element-264" data-mp="3194084iu5iui" />
          </div>)}
      </div>
    </section>;
}